/* import __COLOCATED_TEMPLATE__ from './conversation-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';

export interface ConversationExploreConversation {
  id: number;
  userName: string | null;
  userPseudonym: string | null;
  userEmail: string;
  topicSummary: string;
  subtopic: string;
  topic: string;
  cxExplanation: string;
  cxScore: number;
  cxAttributes: string;
}

interface Args {
  loadedConversations: ConversationExploreConversation[];
  selectedConversationId: number;
  onConversationSelected: (conversationId: number) => void;
  totalHits: number;
  loadMoreConversations: () => void;
  isLoadingMore: boolean;
  conversationFetchError: any;
  isStandalone: boolean;
  trackAnalyticsEvent: (action: string, object: string, extraContext: Record<string, any>) => void;
  hideCXWhenMissing?: boolean;
}

export default class ConversationPanel extends Component<Args> {
  get drillInPermissionError() {
    return this.args.conversationFetchError?.errorThrown === 'Forbidden';
  }

  get selectedConversationCXExplanation() {
    return this.args.loadedConversations.find(
      (conversation) => conversation.id === this.args.selectedConversationId,
    )?.cxExplanation;
  }

  get selectedConversationCXScore() {
    return this.args.loadedConversations.find(
      (conversation) => conversation.id === this.args.selectedConversationId,
    )?.cxScore;
  }

  get selectedConversationCXAttributes() {
    return this.args.loadedConversations.find(
      (conversation) => conversation.id === this.args.selectedConversationId,
    )?.cxAttributes;
  }

  get conversationIds() {
    return this.args.loadedConversations.map((conversation) => conversation.id);
  }

  get hasMoreConversations() {
    return this.args.loadedConversations.length < this.args.totalHits;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::ConversationPanel': typeof ConversationPanel;
    'reporting/automation/ai-insights/conversation-panel': typeof ConversationPanel;
  }
}
